import React from 'react'
import Navbar from '../components/Navbar/Navbar';
import EducationMe from '../components/Education/EducationMe';
import FooterMe from '../components/Footer/FooterMe';
import 'flowbite'
const Education = () => {
  return (
    <>
    <Navbar />
    <EducationMe />
    <FooterMe/>
    </>
  )
}

export default Education